export default __webpack_public_path__ + "static/media/trip.748b1fd6.png";